let userId : string = "";
let lidnummer : string = "";
let bondsId : string = "";
let roles : any[] = [];
let currentRole : string = "";
let currentRolePath : string = "";
let useAccessibleDropdown : boolean = false;

import { CookieManager } from '../cookies';

export class UserService {
  public static isAuthenticated() {
    // TODO: Does not seem very solid
    // The user menu also is not always on the page, even if the user is authenticated
    return !!document.querySelector(".mijn-fnv__user-menu-item-loggedin");
  }

  public static setUserId(value : string) {
      userId = value;
  }

  public static getUserId() {
      return  userId;
  }

  public static setLidnummer(value : string) {
      lidnummer = value;
  }

  public static getLidnummer() {
      return  lidnummer;
  }
  
  public static setBondsId(value : string) {
      bondsId = value;
  }

  public static getBondsId() {
      return  bondsId;
  }
  public static setUserRoles(value : any[]) {
      roles = value;
  }

  public static getUserRoles() {
      return roles;
  }

  public static setCurrentRole(value : string) {
      currentRole = value;
      CookieManager.createCookie("currentMijnFNVRole", value, 365);
  }

  public static getCurrentRole() {
      if (currentRole == "") {
          currentRole = CookieManager.readCookie("currentMijnFNVRole");
      }
      return currentRole;
  }

  public static setCurrentRolePath(value : string) {
      currentRolePath = value;
      CookieManager.createCookie("currentMijnFNVRolePath", value, 365);
  }

  public static getCurrentRolePath() {
      if (currentRolePath == "") {
          currentRolePath = CookieManager.readCookie("currentMijnFNVRolePath");
      }
      return currentRolePath;
  }

  public static removeCookiesOnLogout() {
    CookieManager.deleteCookie("currentMijnFNVRole");
    CookieManager.deleteCookie("currentMijnFNVRolePath");
  }

  public static setUseAccessibleDropdown(value : boolean) {
      useAccessibleDropdown = value;
  }

  public static getUseAccessibleDropdown() {
      return  useAccessibleDropdown;
  }
}